import React from "react";
import { Avatar, Typography, TextField, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { clientPhotoLink } from "../../../../constants";

// css module
import styles from "./client-info.module.scss";

const ClientInfo = (): React.JSX.Element => {
  const clientInfo = useSelector((state: RootState) => state.clientPortalUserInfo.user);

  return (
    <div className={styles.clientInfoCard}>
      <div className={styles.header}>
        <Typography variant="h6" className={styles.title}>
          Profile Information
        </Typography>
        <Typography variant="body2" className={styles.subtitle}>
          Update your personal information and profile details
        </Typography>
      </div>

      <Divider className={styles.divider} />

      <div className={styles.profileSection}>
        <Avatar className={styles.avatar} alt="Profile" src={clientPhotoLink} />
        <div className={styles.profileText}>
          <Typography variant="subtitle1" className={styles.name}>
            {clientInfo?.user?.firstName} {clientInfo?.user?.lastName}
          </Typography>
          <Typography variant="body2" className={styles.email}>
            {clientInfo?.user?.email}
          </Typography>
          {/* <Button variant="outlined" size="small" className={styles.changePhotoBtn}>
            Change Photo
          </Button> */}
        </div>
      </div>

      <div className={styles.form}>
        <TextField
          disabled
          variant="outlined"
          slotProps={{ inputLabel: { shrink: true } }}
          label="First Name"
          defaultValue={clientInfo?.user?.firstName || ""}
          size="small"
          fullWidth
        />
        <TextField
          disabled
          variant="outlined"
          slotProps={{ inputLabel: { shrink: true } }}
          label="Last Name"
          defaultValue={clientInfo?.user?.lastName || ""}
          size="small"
          fullWidth
        />
        <TextField
          disabled
          variant="outlined"
          slotProps={{ inputLabel: { shrink: true } }}
          label="Email Address"
          defaultValue={clientInfo?.user?.email || ""}
          size="small"
          fullWidth
        />
        <TextField
          disabled
          variant="outlined"
          slotProps={{ inputLabel: { shrink: true } }}
          label="Phone Number"
          placeholder="+977 9823458787"
          size="small"
          fullWidth
        />
      </div>
      {/* 
      <div className={styles.actions}>
        <Button variant="contained" color="primary">
          Save Changes
        </Button>
      </div> */}
    </div>
  );
};

export default ClientInfo;
